<template>
  <Segment
    :items="MODES"
    :model-value="mode"
    @update:model-value="handleChange"
  />
</template>

<script setup lang="ts">
import { markRaw } from 'vue'
import { Segment, type SegmentItem } from '@dacr/library'
import { CameraIcon, UploadIcon, VocalAndInstrumentalIcon } from '@dacr/icons'

import type { CheckerMode } from './useChecker'

defineProps<{ mode: CheckerMode }>()

const emit = defineEmits<{ change: [mode: CheckerMode] }>()

const MODES: SegmentItem[] = [
  { label: 'Audio', value: 'audio', icon: markRaw(VocalAndInstrumentalIcon) },
  { label: 'Visual', value: 'visual', icon: markRaw(CameraIcon) },
  { label: 'Upload', value: 'upload', icon: markRaw(UploadIcon) },
]

const isMode = (value: string): value is CheckerMode =>
  MODES.some((item) => item.value === value)

const handleChange = (value: string | undefined) => {
  if (value && isMode(value)) emit('change', value)
}
</script>
